/*
 * @Author: your name
 * @Date: 2021-12-30 15:40:25
 * @LastEditTime: 2022-05-27 14:44:48
 * @LastEditors: Please set LastEditors
 * @Description: 标注
 * @FilePath: \smart-community\src\components\map\js\modular\Marker.js
 */

import 'ol/ol.css';
import VectorSource from 'ol/source/Vector';
import Feature from "ol/Feature";
import { Heatmap as HeatmapLayer, Tile as TileLayer } from 'ol/layer';

import Point from "ol/geom/Point";
import handleCoordinates from "./handleCoordinates";
const { setPoint, setVideoPoint } = handleCoordinates();

class Heatmap {
  map = undefined;
  constructor() {
    this.vectorLayer = undefined;
  }

  // 创建图层
  addHeatMap(myMap, heatData) {
    const self = this
    let source = new VectorSource(); // 新生成图层源,用于存放热力图图层
    heatData.forEach((item) => { // 遍历热力图数据,生成热力图feature
      const feature = new Feature({
        geometry: new Point(setPoint(item.coordinates)),
        weight: item.weight,
      });
      source.addFeature(feature);
    });

    const vectorLayer = new HeatmapLayer({
      source: source,

      blur: 10,
      radius: 15,
      weight(feature) {
        const weight = feature.get("weight"); //获取feature的weight参数值,此处weight不可变更为其他参数,否则失效(暂时不明原因);
        const magnitude = weight / 1;
        return magnitude;
      },
    });
    self.vectorLayer = vectorLayer
    myMap.addLayer(self.vectorLayer);

  }
  clearHeatMap(myMap) {
    const self = this
    if (!self.vectorLayer) return
    myMap.removeLayer(self.vectorLayer);
  }

}
export default Heatmap;